import type { DashboardDto } from "@stryker/core/types/dashboard";
import { useConfigOptions } from "@/hooks/useConfigOptions";

import LineChartComponent from "./charts/LineChart";

type EngCostProps = {
  graphsData?: DashboardDto["cost"];
};
export default function EngCost({ graphsData }: EngCostProps) {
  const { allKits } = useConfigOptions();
  return (
    <div className="flex flex-wrap gap-8 p-4">
      <LineChartComponent
        data={graphsData?.costByRepairSystem ?? []}
        dataKey="repairSystem"
        title="Cost by Repair System"
        lines={[{ lineName: "Cost", lineDataKey: "cost", color: "blue" }]}
      />
      <LineChartComponent
        data={graphsData?.costByBranch ?? []}
        dataKey="branch"
        title="Cost by cost"
        lines={[{ lineName: "Cost", lineDataKey: "cost", color: "blue" }]}
      />
      <LineChartComponent
        data={graphsData?.costByPlant ?? []}
        dataKey="plant"
        title="Cost by plant"
        lines={[{ lineName: "Cost", lineDataKey: "cost", color: "blue" }]}
      />
      <LineChartComponent
        data={graphsData?.costByPerson ?? []}
        dataKey="person"
        title="Cost by person"
        lines={[{ lineName: "Cost", lineDataKey: "cost", color: "blue" }]}
      />
      <LineChartComponent
        data={
          graphsData?.costByKitsSize.map((v) => {
            const kitLabel = allKits.find((k) => String(k.value) === String(v.kitsSize));
            return { ...v, label: kitLabel?.title };
          }) ?? []
        }
        dataKey="label"
        title="Cost by kits Size"
        lines={[{ lineName: "Cost", lineDataKey: "cost", color: "blue" }]}
      />
    </div>
  );
}
